<template src="@/templates/bookings/bookingAvailable.html"></template>

<script>
import BookingAvailableCollection from "@/collections/bookingAvailableCollection";
import BookingListItem from "@/components/bookings/BookingListItem";
import { mapActions } from "vuex";

export default {
  name: "BookingAvailable",
  props: ["booking_view", "booking_type"],
  components: { BookingListItem },
  data() {
    return {
      bookingAvailableCollection: new BookingAvailableCollection(),
      availableError: "",
      parentComp: "",
    };
  },
  computed: {
    availableTitle() {
      if (this.booking_type == "onsite") {
        return "Available Onsite Bookings";
      } else if (this.booking_type == "telephone") {
        return "Available Pre-Booked Telephone Bookings";
      } else if (this.booking_type == "video") {
        return "Available Video Bookings";
      } else {
        return "";
      }
    },
  },
  created: function () {
    console.log(this.booking_view);
    this.getBookingAvailable();
  },
  watch: {
    $route: "getBookingAvailable",
  },
  methods: {
    ...mapActions(["availableBooking", "updateHideAll", "updateBackButton"]),
    setParentComp() {
      if (this.booking_type == "onsite") {
        this.parentComp = "bookingavailable_onsite";
      } else if (this.booking_type == "telephone") {
        this.parentComp = "bookingavailable_telephone";
      } else if (this.booking_type == "video") {
        this.parentComp = "bookingavailable_video";
      }
    },
    getBookingAvailable() {
      this.setParentComp();

      this.updateHideAll();
      this.updateBackButton(false);

      this.bookingAvailableCollection
        .fetch({
          url:
            this.$interpretersApiUrl +
            this.bookingAvailableCollection.getRoute("fetch") +
            this.booking_type,
          headers: { Bearer: localStorage.getItem("jwt") },
        })
        .then((result) => {
          console.log("this is response");
          console.log(result);
          console.log(this.bookingAvailableCollection.models);
          if (this.bookingAvailableCollection.models.length === 0) {
            this.availableBooking(false);
          } else {
            this.availableBooking(true);
          }
        })
        .catch((error) => {
          console.error("error status code");
          console.log(error.response.response.status);
          if (error.response) {
            if (error.response.response.status == "401") {
              Event.$emit("tokenExpiredLogout");
              return;
            }
          }

          let res = error.response.response.data;
          if (res) {
            if (res.invalid_police_check) {
              this.availableError = "Please provide valid police check.";
            }
          } else {
            console.error(error);
            debugger;
          }
        });
    },
  },
};
</script>

<style scoped>
#availableHeader {
  text-align: left;
  list-style: none;
}

#availableHeader li {
  margin-bottom: 8px;
}

#ulBookingAvailable {
  list-style: none;
}

#ulBookingAvailable > li {
  padding: 10px;
}

#ulBookingAvailable > li:nth-child(odd) {
  background: #ffffff;
}

#ulBookingAvailable > li:nth-child(even) {
  background: #eeeeee;
}
</style>
